export const TRIAL_DAYS = 14;
/** Days 12–14 of 14: the banner names what changes — the mock's matrix. */
export const TRIAL_CLOSING_DAYS = 3;
const DAY_MS = 24 * 60 * 60 * 1000;
/** Whole days left, counting a part day as one. `0` once the trial has ended. */
export function trialDaysLeft(trialEndsAt, now) {
    return Math.max(0, Math.ceil((trialEndsAt.getTime() - now.getTime()) / DAY_MS));
}
export function trialPhase(trialEndsAt, now) {
    if (trialEndsAt === null)
        return "none";
    if (now.getTime() >= trialEndsAt.getTime())
        return "ended";
    return trialDaysLeft(trialEndsAt, now) <= TRIAL_CLOSING_DAYS ? "closing" : "quiet";
}
/**
 * Whether the trial clock moves this organisation to Launch now.
 *
 * `none` and not `paid`: a subscription that ever started ends the trial, and its later
 * states are the ladder's to answer — Drift Log §U61.
 */
export function trialLapses(facts) {
    return (facts.plan !== "launch" &&
        facts.standing === "none" &&
        trialPhase(facts.trialEndsAt, facts.now) === "ended");
}
//# sourceMappingURL=trial.js.map